/* Nordic Weaving: Gem til senere i kurven. Bygget 8/9-2026.

   Virker på BEGGE flader med én implementering, fordi kurv-skuffen og kurvsiden
   deler varelinjen og dermed klasserne .cart-item, .cart-item__remove og
   .cart-item__quantity-input[data-key].

   MUTATIONOBSERVER: temaet gentegner hele .cart-item-list__body
   (data-merge-list="cart-items") ved hver antalsændring. Alt vi skyder ind i en
   varelinje bliver kastet væk igen. Samme fælde som lagerkontrollen i søvnguiden,
   hvor rettelsen hang på renderResult i stedet for på #addons.

   KRITISK, målt 8/9 om aftenen: observeren lytter på HELE dokumentet, og siden
   ændrer sig hele tiden af sig selv, hover-effekter, dovne billeder, karruseller,
   apps. Første version gentegnede boksen ved HVER ændring. Målt: 152 gentegninger
   på fire sekunder mens musen bare lå stille. Konsekvensen var ikke kosmetisk.
   Når et element udskiftes mellem mousedown og mouseup, får det aldrig sit klik,
   og browseren sender klikket til en fælles forfader i stedet. Derfor blinkede
   knapperne, derfor skulle man trykke to gange, derfor virkede plus og minus
   på antal ikke, og derfor kunne skuffen ikke lukkes på første tryk.

   Tre værn mod det, og alle tre skal blive stående:
   1. SIGNATUR. Boksen gentegnes kun når indholdet faktisk er et andet.
   2. PAUSE. Observeren kobles fra mens vi selv skriver i DOM'en, så vi ikke
      vækker os selv.
   3. DELEGERING. Ét klik-lyt på boksen, sat på én gang. Ikke en ny lytter
      pr. knap pr. gentegning.

   TOM KURV: skuffen lægger klassen cart-drawer__content--hidden på hele
   indholdsblokken og viser i stedet .cart-drawer__empty-content ovenpå.
   Boksen skal derfor flyttes DERIND når kurven er tom, ellers står den bag
   den tomme tilstand. Det er netop dér den er mest værd, for en tom kurv er
   ellers en blindgyde selv for en kunde med ti gemte varer.

   RÆKKEFØLGE: krydssalget skal stå FØR de gemte varer. Krydssalget handler om
   den kurv kunden er ved at bygge nu. De gemte varer er en parkeringsplads.

   VI KLIKKER TEMAETS EGET FJERN-LINK i stedet for at kalde /cart/change.js:
   så håndterer temaet selv fjernelsen, gentegningen og totalerne.

   PRIS OG LAGER HENTES PÅ NY: det gemte i localStorage er kun et øjebliksbillede.
   En vare kan ligge gemt i uger.

   Afhænger af NWWishlist fra assets/nw-wishlist.js. Er den der ikke, gør filen intet.
*/
(function (w, d) {
  'use strict';

  var LISTE   = '.cart-item-list__body';
  var BOKS_ID = 'nw-gem-boks';
  var cache   = {};
  var travl   = false;

  var observer       = null;
  var sidsteSignatur = null;

  var HJERTE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21.2l7.8-7.7 1-1.1a5.5 5.5 0 0 0 0-7.8z"/></svg>';

  /* ALTID TO DECIMALER, rettet 10/9-2026. Se den samme note i nw-xs.js.
     Målt: det samme produkt stod med "Fra 449,00 kr" i krydssalget og
     "449 kr" her, i samme skærmbillede. Temaets money-filter skriver altid
     to decimaler, og det er formatet resten af kurven bruger. */
  function kr(oere) {
    if (oere === null || oere === undefined || isNaN(oere)) return '';
    var v = oere / 100;
    return (Math.round(v * 100) / 100).toLocaleString('da-DK', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }) + ' kr';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* Shopifys width-parameter frem for _220x-suffikset: suffikset må ikke stå to
     gange, og den gemte URL kan have det i forvejen. Samme regel som ønskeseddel-siden. */
  function sized(url, bredde) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (bredde || 200);
  }

  function hentProdukt(handle) {
    if (!handle) return Promise.resolve(null);
    if (cache[handle] !== undefined) return Promise.resolve(cache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (p) { cache[handle] = p; return p; });
  }

  /* Alt hvad vi selv skriver i DOM'en skal ske herinde. Ellers vækker vores
     egen skrivning observeren, som gentegner, som skriver igen. */
  function udenAtVaekkeOsSelv(fn) {
    if (observer) observer.disconnect();
    try { fn(); }
    finally {
      if (observer) {
        observer.takeRecords();
        observer.observe(d.documentElement, { childList: true, subtree: true });
      }
    }
  }

  function kvittering(tekst) {
    var el = d.getElementById('nw-gem-toast');
    udenAtVaekkeOsSelv(function () {
      if (!el) {
        el = d.createElement('div');
        el.id = 'nw-gem-toast';
        el.className = 'nw-gem-toast';
        el.setAttribute('role', 'status');
        d.body.appendChild(el);
      }
      el.textContent = tekst;
      el.classList.add('on');
    });
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('on'); }, 2600);
  }

  /* Temaets egen opdatering af skuffen. Verificeret 8/9-2026: eventet henter
     kurven forfra fra serveren. På kurvsiden findes ingen tilsvarende krog. */
  function opdaterKurv() {
    try {
      d.documentElement.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    } catch (e) {}
    if (/^\/cart/.test(w.location.pathname)) {
      setTimeout(function () { w.location.reload(); }, 350);
    }
  }

  /* ---------- Gem til senere på varelinjen ---------- */

  function saetKnapperInd() {
    var manglende = [];
    d.querySelectorAll('.cart-item').forEach(function (linje) {
      if (linje.querySelector('.nw-gem-btn')) return;
      var fjern = linje.querySelector('.cart-item__remove');
      var felt  = linje.querySelector('.cart-item__quantity-input');
      if (!fjern || !felt || !felt.getAttribute('data-key')) return;
      manglende.push({
        fjern: fjern,
        noegle: felt.getAttribute('data-key'),
        /* Den nye varelinje har en tom .nwci__akt til formålet. Fjern er
           blevet et skraldespandsikon øverst til højre, så knappen må IKKE
           længere sættes ind ved siden af den. Findes pladsen ikke, fx på
           temaets gamle linje, falder vi tilbage til den gamle placering. */
        plads: linje.querySelector('.nwci__akt')
      });
    });
    if (!manglende.length) return;

    udenAtVaekkeOsSelv(function () {
      manglende.forEach(function (m) {
        var b = d.createElement('button');
        b.type = 'button';
        b.className = 'nw-gem-btn';
        b.innerHTML = HJERTE + '<span>Gem til senere</span>';
        b.addEventListener('click', function () { gem(m.noegle, b, m.fjern); });
        if (m.plads) m.plads.appendChild(b);
        else m.fjern.parentNode.insertBefore(b, m.fjern);
      });
    });
  }

  function gem(noegle, knap, fjernLink) {
    if (travl || !w.NWWishlist) return;
    travl = true;
    knap.disabled = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var linje = null;
        for (var i = 0; i < c.items.length; i++) {
          if (c.items[i].key === noegle) { linje = c.items[i]; break; }
        }
        if (!linje) throw new Error('linje ikke fundet');

        w.NWWishlist.add({
          v: linje.variant_id,
          h: linje.handle,
          t: linje.product_title,
          p: linje.price,
          img: linje.image || '',
          s: (linje.variant_title && linje.variant_title !== 'Default Title') ? linje.variant_title : ''
        });

        kvittering('Gemt til senere. Den ligger lige nedenfor.');
        travl = false;
        fjernLink.click();
      })
      .catch(function () {
        travl = false;
        knap.disabled = false;
        kvittering('Kunne ikke gemme varen. Prøv igen.');
      });
  }

  /* ---------- boksen Gemt til senere ---------- */

  function raekke(vare) {
    var url = vare.h ? '/products/' + vare.h + '?variant=' + vare.v : '#';
    return '<li class="nw-gem__it" data-v="' + esc(vare.v) + '">'
      + '<a class="nw-gem__ph" href="' + esc(url) + '">'
      +   (vare.img ? '<img src="' + esc(sized(vare.img, 200)) + '" alt="" loading="lazy">' : '')
      + '</a>'
      + '<div class="nw-gem__bd">'
      +   '<a class="nw-gem__nm" href="' + esc(url) + '">' + esc(vare.t) + '</a>'
      +   (vare.s ? '<p class="nw-gem__vr">' + esc(vare.s) + '</p>' : '')
      +   '<p class="nw-gem__st" data-st>Henter …</p>'
      + '</div>'
      + '<div class="nw-gem__rt">'
      +   '<span class="nw-gem__pr" data-pr>' + kr(vare.p) + '</span>'
      +   '<button type="button" class="nw-gem__add" data-add disabled>Læg i kurv</button>'
      +   '<button type="button" class="nw-gem__del" data-del>Fjern</button>'
      + '</div>'
      + '</li>';
  }

  /* Hvor boksen skal bo lige nu. Er kurven tom, skjuler skuffen sin
     indholdsblok, og så skal boksen ind i den tomme tilstand i stedet. */
  function findVaert() {
    var tom = d.querySelectorAll('.cart-item').length === 0;

    if (tom) {
      var tomBoks = d.querySelector('.cart-drawer__empty-content .align-center')
                 || d.querySelector('.cart-drawer__empty-content');
      if (tomBoks && tomBoks.getBoundingClientRect().height > 0) {
        return { el: tomBoks, indeni: true };
      }
    }
    var liste = d.querySelector(LISTE);
    return liste ? { el: liste, indeni: false } : null;
  }

  /* Krydssalget skal stå FØR de gemte varer, så boksen skal ind EFTER det.
     Krydssalget handler om den kurv kunden bygger nu. De gemte varer er en
     parkeringsplads, og en parkeringsplads skal ikke stå foran butikken.

     De to flader har IKKE samme træ, og det kostede et forsøg at opdage:
     - kurvsiden: .nwxs er søskende til .cart-item-list__body.
     - skuffen: .cart-item-upsells ligger i en HELT anden blok, bare under
       samme forælder .cart-drawer__content-upper.
     Derfor klatrer vi op fra krydssalget indtil vi står på et niveau der
     også rummer varelisten, i stedet for at gætte på søskende. */
  function maalPlacering(vaert) {
    if (vaert.indeni) return { foraelder: vaert.el, efter: null };

    var liste = vaert.el;
    var xs = d.querySelector('.nwxs')
          || d.querySelector('.cart-item-upsells:not(.cart-item-upsells--left)');

    if (xs && !xs.classList.contains('hidden')) {
      var a = xs;
      while (a && a.parentNode && !a.parentNode.contains(liste)) a = a.parentNode;
      if (a && a.parentNode) return { foraelder: a.parentNode, efter: a };
    }
    return { foraelder: liste.parentNode, efter: liste };
  }

  /* Skuffens egne blokke har klassen .cart-drawer__content-item, som giver dem
     vandret luft (målt: 32 px). Vores boks er en direkte søskende UDEN den
     klasse, så den gik helt ud til kanten og lignede ikke et kort.

     Vi aflæser naboens padding i stedet for at skrive 32 px ind: temaet
     ændrer værdien på små skærme, og et hårdkodet tal ville være forkert
     præcis dér hvor det ses mest. Samme regel som alle andre steder i denne
     butik: hent værdien, gæt den ikke. */
  function tilpasIndryk(boks) {
    var iSkuffen = boks.parentNode
      && boks.parentNode.classList
      && boks.parentNode.classList.contains('cart-drawer__content-upper');

    if (!iSkuffen) {
      if (boks.style.paddingLeft) { boks.style.paddingLeft = ''; boks.style.paddingRight = ''; }
      return;
    }
    var nabo = d.querySelector('.cart-drawer__content-upper .cart-drawer__content-item');
    if (!nabo) return;
    var p = getComputedStyle(nabo).paddingLeft;

    /* PADDING og ikke margin. Boksen ligger i skuffen på en sandfarvet flade
       der skal gå helt ud til kanten, mens teksten skal flugte med
       varelisten. Med margin ville selve sandfarven blive trukket ind, og så
       stod der to hvide striber langs siderne. */
    if (p && p !== '0px' && boks.style.paddingLeft !== p) {
      boks.style.paddingLeft = p;
      boks.style.paddingRight = p;
    }
  }

  function signatur(varer, vaert) {
    return (vaert.indeni ? 'tom|' : 'liste|') + varer.map(function (v) { return v.v; }).join(',');
  }

  function tegnBoks(tvungen) {
    if (!w.NWWishlist) return;

    var vaert = findVaert();
    var varer = w.NWWishlist.all();
    var boks  = d.getElementById(BOKS_ID);

    /* Er der intet gemt, forsvinder kassen helt. Ikke en tom boks med en
       opfordring: plads i en skuffe er dyr, og funktionen opdages på
       varelinjen, ikke i en tom kasse. */
    if (!varer.length || !vaert) {
      if (boks && boks.parentNode) {
        udenAtVaekkeOsSelv(function () { boks.parentNode.removeChild(boks); });
      }
      sidsteSignatur = null;
      return;
    }

    var maal = maalPlacering(vaert);
    var korrektForaelder = maal.foraelder;
    var sig = signatur(varer, vaert);

    /* Står boksen allerede rigtigt? Både forælder OG naboen skal passe.
       Krydssalget i skuffen findes først EFTER at skuffen er åbnet, så
       forælderen kan være rigtig mens rækkefølgen stadig er forkert. Kun at
       tjekke forælderen ville låse boksen fast over krydssalget for altid. */
    var staarRigtigt = boks && boks.isConnected
      && boks.parentNode === korrektForaelder
      && (maal.efter === null || boks.previousElementSibling === maal.efter);

    /* Værnet. Uden det gentegnes boksen ved enhver ændring et vilkårligt sted
       på siden, og så kan man ikke ramme dens knapper med et rigtigt klik. */
    if (!tvungen && staarRigtigt && sig === sidsteSignatur) return;

    var skalTegne = tvungen || !boks || sig !== sidsteSignatur || !boks.firstChild;

    udenAtVaekkeOsSelv(function () {
      if (!boks) {
        boks = d.createElement('section');
        boks.id = BOKS_ID;
        boks.className = 'nw-gem';
      }
      if (!staarRigtigt) {
        /* Flyt det SAMME element. Bygger vi et nyt, mister vi klik-lytteren
           og alt hvad der er hentet ind i rækkerne. */
        if (maal.efter) maal.foraelder.insertBefore(boks, maal.efter.nextSibling);
        else maal.foraelder.appendChild(boks);
      }

      /* Kun ved ændret indhold. Skal boksen bare FLYTTES, må rækkerne blive
         stående: en gentegning smider de hentede priser og lagertal væk og
         beder om dem igen for ingenting. */
      if (skalTegne) {
        var antal = varer.length === 1 ? '1 vare' : varer.length + ' varer';
        boks.innerHTML =
            '<div class="nw-gem__hd"><h2>Gemt til senere</h2><span>' + antal + '</span></div>'
          + '<p class="nw-gem__sub">Ligger på din enhed. Pris og lager hentes på ny, hver gang du kigger.</p>'
          + '<ul class="nw-gem__list">' + varer.map(raekke).join('') + '</ul>';
      }

      /* Én lytter pr. boks, sat én gang. Bindes den pr. knap pr. gentegning,
         står de i kø og fyrer flere gange for det samme klik. Flaget sidder på
         ELEMENTET og ikke i en variabel udenfor: bygges boksen om, skal den nye
         boks også have sin lytter. */
      if (!boks._nwLyt) {
        boks.addEventListener('click', paaKlik);
        boks._nwLyt = true;
      }

      tilpasIndryk(boks);
    });

    sidsteSignatur = sig;
    if (skalTegne) boks.querySelectorAll('.nw-gem__it').forEach(function (li) { fyldUd(li); });
  }

  function paaKlik(e) {
    var li = e.target.closest ? e.target.closest('.nw-gem__it') : null;
    if (!li) return;
    var vid = li.getAttribute('data-v');

    if (e.target.closest('[data-del]')) {
      w.NWWishlist.remove(vid);
      tegnBoks(true);
      kvittering('Fjernet fra dine gemte.');
      return;
    }
    var add = e.target.closest('[data-add]');
    if (add && !add.disabled) tilbage(vid, add);
  }

  function fyldUd(li) {
    var vid = li.getAttribute('data-v');
    var vare = null, alle = w.NWWishlist.all();
    for (var i = 0; i < alle.length; i++) { if (String(alle[i].v) === vid) { vare = alle[i]; break; } }
    if (!vare) return;

    var stEl  = li.querySelector('[data-st]');
    var prEl  = li.querySelector('[data-pr]');
    var addEl = li.querySelector('[data-add]');

    hentProdukt(vare.h).then(function (p) {
      /* Boksen kan være gentegnet imens. Skriv aldrig i et element der er
         koblet af dokumentet, det er usynligt arbejde der forvirrer næste læser. */
      if (!li.isConnected) return;

      if (!p) { stEl.textContent = 'Varen findes ikke længere'; stEl.className = 'nw-gem__st is-out'; return; }

      var v = null;
      for (var i = 0; i < p.variants.length; i++) {
        if (String(p.variants[i].id) === vid) { v = p.variants[i]; break; }
      }
      if (!v) { stEl.textContent = 'Den valgte størrelse findes ikke længere'; stEl.className = 'nw-gem__st is-out'; return; }

      udenAtVaekkeOsSelv(function () {
        prEl.textContent = '';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var s = d.createElement('s'); s.textContent = kr(v.compare_at_price); prEl.appendChild(s);
        }
        prEl.appendChild(d.createTextNode(kr(v.price)));

        /* Prisfald siden varen blev gemt. Det er den bedste grund til
           overhovedet at gemme noget, så det skal siges højt. */
        if (vare.p && v.price < vare.p) {
          var fald = d.createElement('span');
          fald.className = 'nw-gem__drop';
          fald.textContent = 'Faldet ' + kr(vare.p - v.price);
          prEl.appendChild(fald);
        }

        if (v.available) {
          stEl.textContent = 'På lager';
          stEl.className = 'nw-gem__st';
          addEl.disabled = false;
        } else {
          stEl.textContent = 'Udsolgt lige nu';
          stEl.className = 'nw-gem__st is-out';
          addEl.disabled = true;
          addEl.textContent = 'Udsolgt';
        }
      });
    });
  }

  function tilbage(vid, knap) {
    if (travl) return;
    travl = true;
    knap.disabled = true;
    /* KORT TEKST, rettet 10/9-2026. Den hed "Lægger i kurv …" og var 145 px
       mod knappens 108 px i hviletilstand. Målt. Rækken på telefon er pris,
       knap og Fjern på én linje med space-between, og ingen af de tre kan
       krympe: prisen og knappen har begge white-space:nowrap. De 37 px
       ekstra skubbede derfor Fjern ud over skærmkanten, hvilket Mads så.
       "Lægger i …" er 112 px, og nw-gem.css reserverer 112 px i forvejen,
       så knappen står nu helt stille når teksten skifter. */
    knap.textContent = 'Lægger i …';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add fejlede'); })
      .then(function () {
        w.NWWishlist.remove(vid);
        kvittering('Lagt i kurven igen.');
        travl = false;
        opdaterKurv();
        tegnBoks(true);
      })
      .catch(function () {
        travl = false;
        knap.disabled = false;
        knap.textContent = 'Læg i kurv';
        kvittering('Kunne ikke lægge varen i kurven.');
      });
  }

  /* ---------- opsætning ---------- */

  function koer() {
    saetKnapperInd();
    tegnBoks(false);
  }

  var planlagt = null;
  function planlaeg() {
    if (planlagt) return;
    planlagt = setTimeout(function () { planlagt = null; koer(); }, 120);
  }

  function start() {
    if (!w.NWWishlist) return;
    koer();

    /* Observeren skal ligge på documentElement og ikke på selve listen:
       temaet udskifter hele listens indhold, og i skuffen findes listen
       først når skuffen er blevet åbnet første gang. */
    try {
      observer = new MutationObserver(planlaeg);
      observer.observe(d.documentElement, { childList: true, subtree: true });
    } catch (e) {}

    /* Skifter listen andetsteds, fx et hjerte på en produktside, følger boksen med. */
    d.addEventListener('nw:wishlist:change', function () { tegnBoks(true); });

    /* Fjern på en SAMMENLAGT række skal fjerne hele gruppen.

       Baggrund: Shopifys køb-X-få-Y-rabat splitter en varelinje i to, og
       nw-cart-item.liquid lægger dem sammen til én række med de øvrige
       nøgler som skjulte updates[]-felter på 0. Temaets fjern-link kalder
       /cart/change med ÉN nøgle og ville derfor efterlade dubletten.

       Vi sætter i stedet antallet til 0 og lader temaet sende hele
       formularen. Verificeret 9/9: en change på antalsfeltet udløser
       /cart/update.js med samtlige updates[]-værdier.

       Capture-fasen, så vi kommer før temaets egen lytter. Vi rører kun
       links der bærer data-nw-samlet, så almindelige rækker er urørte. */
    d.addEventListener('click', function (e) {
      var lnk = e.target && e.target.closest ? e.target.closest('.cart-item__remove[data-nw-samlet]') : null;
      if (!lnk) return;
      var linje = lnk.closest('.cart-item');
      var felt  = linje && linje.querySelector('.cart-item__quantity-input');
      if (!felt) return;
      e.preventDefault();
      e.stopPropagation();
      felt.value = '0';
      felt.dispatchEvent(new Event('change', { bubbles: true }));
    }, true);

    /* Indrykningen aflæses fra naboen, og naboens padding ændrer sig ved
       skift af skærmbredde. En resize er ikke en DOM-ændring, så observeren
       fanger den ikke. */
    var rt = null;
    w.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        var b = d.getElementById(BOKS_ID);
        if (b) udenAtVaekkeOsSelv(function () { tilpasIndryk(b); });
      }, 150);
    });
  }

  if (w.NWWishlist) {
    d.readyState === 'loading' ? d.addEventListener('DOMContentLoaded', start) : start();
  } else {
    d.addEventListener('nw:wishlist:ready', start, { once: true });
  }
})(window, document);
